import type { ComponentType } from 'react';

export const systemItems: Array<{ text: string; icon: ComponentType; path: string }> = [];